<div *ngIf="!(isLoaded || (isLoaded$ | async))" class="layer-load-icon-wrap">
    <i class="fas fa-spinner layer-load-icon"></i>
</div>